import React from 'react';

const BatchWizard = ({ isOpen, onClose, assessment }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full">
        <h3 className="text-xl font-bold mb-4">Group Wizard</h3>
        <p className="text-gray-600 mb-6">Initializing group for: <strong>{assessment?.name}</strong></p>
        <div className="flex justify-end gap-3">
          <button onClick={onClose} className="btn-assessment btn-assessment-secondary">Close</button>
          <button className="btn-assessment btn-assessment-danger">Initialize</button>
        </div>
      </div>
    </div>
  );
};

export default BatchWizard;
